import { Address } from "viem";
import { USDC } from "./UsdcValue";
import { IndexerCharity } from "../web3/Types";

export class Charity {
  name: string;
  website: string;
  donationsReceived: USDC;
  drawsInvolved: bigint;
  highestDonationReceived: USDC;
  address?: Address;

  constructor(
    name: string,
    website: string,
    donationsReceived: USDC,
    drawsInvolved: bigint,
    highestDonationReceived: USDC,
    address?: Address,
  ) {
    this.name = name;
    this.website = website;
    this.donationsReceived = donationsReceived;
    this.drawsInvolved = drawsInvolved;
    this.highestDonationReceived = highestDonationReceived;
    this.address = address;
  }

  static fromGraph(data: IndexerCharity): Charity {
    return new Charity(
      data.name,
      data.website,
      new USDC(BigInt(data.donationsReceived)),
      BigInt(data.drawsInvolved),
      new USDC(BigInt(data.highestDonationReceived)),
      data.charityAddress as Address,
    );
  }
}
